import React from 'react';
import propTypes from 'prop-types';

import {
  shouldDisplaySeparateDays,
  weekDays,
  getTime,
} from './Util';

export const StoreHours = ({ hours }) => {
  const shouldDisplaySeparate = shouldDisplaySeparateDays(hours);

  if (shouldDisplaySeparate) {
    const formattedWeekdays = weekDays.map((day) => (
      <li className="cmp-store-information__store-hours" key={day}>
        <span>
          {`${day.charAt(0).toUpperCase()}${day.substring(1)}`}
        </span>
        {' '}
        {getTime(hours[day])}
      </li>
    ));

    return (
      <ul>
        {formattedWeekdays}
        <li className="cmp-store-information__store-hours">
          <span>
            Saturday
          </span>
          {' '}
          {getTime(hours.saturday)}
        </li>
        <li className="cmp-store-information__store-hours">
          <span>
            Sunday
          </span>
          {' '}
          {getTime(hours.sunday)}
        </li>
      </ul>
    );
  }

  return (
    <ul>
      <li>
        Monday-Friday
        {' '}
        {getTime(hours.monday)}
      </li>
      <li className="cmp-store-information__store-hours">
        Saturday
        {' '}
        {getTime(hours.saturday)}
      </li>
      <li className="cmp-store-information__store-hours">
        Sunday
        {' '}
        {getTime(hours.sunday)}
      </li>
    </ul>
  );
};

StoreHours.propTypes = {
  hours: propTypes.shape({
    monday: propTypes.shape({
      openIntervals: propTypes.arrayOf(
        propTypes.shape({
          start: propTypes.string,
          end: propTypes.string,
        }),
      ),
      isClosed: propTypes.bool,
    }),
    saturday: propTypes.shape({
      openIntervals: propTypes.arrayOf(
        propTypes.shape({
          start: propTypes.string,
          end: propTypes.string,
        }),
      ),
      isClosed: propTypes.bool,
    }),
    sunday: propTypes.shape({
      openIntervals: propTypes.arrayOf(
        propTypes.shape({
          start: propTypes.string,
          end: propTypes.string,
        }),
      ),
      isClosed: propTypes.bool,
    }),
  }),
};
